export const SITE_URL = "https://tiraspa.com";

export const BUSINESS = {
  name: "Tira Spa",
  shortName: "Tira",
  tagline: "Sanctuary of Ancient Rituals & Modern Revival",
  phone: "+91 90004 38800",
  phoneClean: "+919000438800",
  phoneDisplay: "+91 90004 38800",
  address:
    "3rd Floor, Pillar No. 1610, Metro, above Fashion Factory Building, Tira Spa, F No. 303, Rohit Goud Estate, Kothapet, Hyderabad, Telangana 500035",
  addressShort: "Kothapet, Hyderabad, Telangana 500035",
  landmark: "Metro Pillar No. 1610, above Fashion Factory Building, Kothapet",
  city: "Hyderabad",
  website: SITE_URL + "/",
  mapsEmbedSrc:
    "https://www.google.com/maps?q=Rohit+Goud+Estate+Kothapet+Hyderabad+Telangana+500035&output=embed",
  mapsDirectionsUrl:
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent(
      "Rohit Goud Estate, F No. 303, Kothapet, Hyderabad, Telangana 500035"
    ),
};
